import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import { assertArgument } from "../utils/index.js";
import { JsonRpcApiPollingProvider } from "./provider-jsonrpc.js";
;
/**
 *  A **BrowserProvider** is intended to wrap an injected provider which
 *  adheres to the [[link-eip-1193]] standard, which most (if not all)
 *  currently do.
 */
var _request = /*#__PURE__*/new WeakMap();
export var BrowserProvider = /*#__PURE__*/function (_JsonRpcApiPollingPro) {
  _inherits(BrowserProvider, _JsonRpcApiPollingPro);
  var _super = _createSuper(BrowserProvider);
  /**
   *  Connnect to the %%ethereum%% provider, optionally forcing the
   *  %%network%%.
   */
  function BrowserProvider(ethereum, network) {
    var _this;
    _classCallCheck(this, BrowserProvider);
    _this = _super.call(this, network, {
      batchMaxCount: 1
    });
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _request, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this), _request, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, params) {
        var payload, result, error;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = {
                method: method,
                params: params
              };
              _this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
              });
              _context.prev = 2;
              _context.next = 5;
              return ethereum.request(payload);
            case 5:
              result = _context.sent;
              _this.emit("debug", {
                action: "receiveEip1193Result",
                result: result
              });
              return _context.abrupt("return", result);
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              error = new Error(_context.t0.message);
              error.code = _context.t0.code;
              error.data = _context.t0.data;
              error.payload = payload;
              _this.emit("debug", {
                action: "receiveEip1193Error",
                error: error
              });
              throw error;
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(BrowserProvider, [{
    key: "send",
    value: function () {
      var _send2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(method, params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._start();
            case 2:
              _context2.next = 4;
              return _get(_getPrototypeOf(BrowserProvider.prototype), "send", this).call(this, method, params);
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function send(_x3, _x4) {
        return _send2.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "_send",
    value: function () {
      var _send3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              assertArgument(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
              _context3.prev = 1;
              _context3.next = 4;
              return _classPrivateFieldGet(this, _request).call(this, payload.method, payload.params || []);
            case 4:
              result = _context3.sent;
              return _context3.abrupt("return", [{
                id: payload.id,
                result: result
              }]);
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", [{
                id: payload.id,
                error: {
                  code: _context3.t0.code,
                  data: _context3.t0.data,
                  message: _context3.t0.message
                }
              }]);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 8]]);
      }));
      function _send(_x5) {
        return _send3.apply(this, arguments);
      }
      return _send;
    }()
  }, {
    key: "getRpcError",
    value: function getRpcError(payload, error) {
      error = JSON.parse(JSON.stringify(error));
      // EIP-1193 gives us some machine-readable error codes, so rewrite
      // them into 
      switch (error.error.code || -1) {
        case 4001:
          error.error.message = "ethers-user-denied: ".concat(error.error.message);
          break;
        case 4200:
          error.error.message = "ethers-unsupported: ".concat(error.error.message);
          break;
      }
      return _get(_getPrototypeOf(BrowserProvider.prototype), "getRpcError", this).call(this, payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */
  }, {
    key: "hasSigner",
    value: function () {
      var _hasSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(address) {
        var accounts;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (address == null) {
                address = 0;
              }
              _context4.next = 3;
              return this.send("eth_accounts", []);
            case 3:
              accounts = _context4.sent;
              if (!(typeof address === "number")) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", accounts.length > address);
            case 6:
              address = address.toLowerCase();
              return _context4.abrupt("return", accounts.filter(function (a) {
                return a.toLowerCase() === address;
              }).length !== 0);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function hasSigner(_x6) {
        return _hasSigner.apply(this, arguments);
      }
      return hasSigner;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(address) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (address == null) {
                address = 0;
              }
              _context5.next = 3;
              return this.hasSigner(address);
            case 3:
              if (_context5.sent) {
                _context5.next = 13;
                break;
              }
              _context5.prev = 4;
              _context5.next = 7;
              return _classPrivateFieldGet(this, _request).call(this, "eth_requestAccounts", []);
            case 7:
              _context5.next = 13;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](4);
              payload = _context5.t0.payload;
              throw this.getRpcError(payload, {
                id: payload.id,
                error: _context5.t0
              });
            case 13:
              _context5.next = 15;
              return _get(_getPrototypeOf(BrowserProvider.prototype), "getSigner", this).call(this, address);
            case 15:
              return _context5.abrupt("return", _context5.sent);
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 9]]);
      }));
      function getSigner(_x7) {
        return _getSigner.apply(this, arguments);
      }
      return getSigner;
    }()
  }]);
  return BrowserProvider;
}(JsonRpcApiPollingProvider);